module.exports = __webpack_public_path__ + "static/media/Poop-Small-Smile-Blink.9fa15e2d.png";